// NOTE: Please keep this file organized, import components, pipes and modules to corresponding sections marked below!

//START COMPONENTS
import { SmallButtonComponent } from './components/small-button/small-button.component';
import { TopMenuBarComponent } from './components/top-menu-bar/top-menu-bar.component';
import { UserAccountButtonComponent } from './components/user-account-button/user-account-button.component';
import { EmojiComponent } from '@ctrl/ngx-emoji-mart/ngx-emoji';
import { NavigationMenuComponent } from './components/navigation-menu/navigation-menu.component';
import { GlobalLocalAlertsComponent } from './components/global-local-alerts/global-local-alerts.component';
import { DefaultContainerComponent } from './components/top-menu-bar/search-bar/default-container/default-container.component';
import { PopularTagsContainerComponent } from './components/top-menu-bar/search-bar/popular-tags/popular-tags-container.component';
import { SingleTagComponent } from './components/top-menu-bar/search-bar/popular-tags/single-tag/single-tag.component';
import { CategoriesComponent } from './components/top-menu-bar/search-bar/results-container/categories/categories.component';
import { ResultsContainerComponent } from './components/top-menu-bar/search-bar/results-container/results-container.component';
import { SearchBarComponent } from './components/top-menu-bar/search-bar/search-bar.component';
import { UserPanelBodyComponent } from './components/user-panel/user-panel-body/user-panel-body.component';
import { UserPanelFooterComponent } from './components/user-panel/user-panel-footer/user-panel-footer.component';
import { UserPanelHeaderComponent } from './components/user-panel/user-panel-header/user-panel-header.component';
import { UserPanelComponent } from './components/user-panel/user-panel.component';
import { FooterAppListComponent } from '../shared/components/footer/footer-app-list/footer-app-list.component';
import { FooterBottomBarComponent } from '../shared/components/footer/footer-bottom-bar/footer-bottom-bar.component';
import { FooterMenuComponent } from '../shared/components/footer/footer-menu/footer-menu.component';
import { FooterMobileAppsComponent } from '../shared/components/footer/footer-mobile-apps/footer-mobile-apps.component';
import { ActionButtonComponent } from './components/action-button/action-button.component';
import { AchievementsComponent } from './components/conversation-panel/chat-create-message/achievements/achievements.component';
import { ChatCreateMessageComponent } from './components/conversation-panel/chat-create-message/chat-create-message.component';
import { CreateMessageComponent } from './components/conversation-panel/chat-create-message/create-message/create-message.component';
import { SingleMessageComponent } from './components/conversation-panel/chat-messages/single-message/single-message.component';
import { ConversationPanelComponent } from './components/conversation-panel/conversation-panel.component';
import { EnlargedSectionsTitleComponent } from './components/enlarged-sections-title/enlarged-sections-title.component';
import { FaqInformationsItemComponent } from './components/faq-informations/faq-informations-item/faq-informations-item.component';
import { FaqInformationsComponent } from './components/faq-informations/faq-informations.component';
import { FooterBottombarComponent } from './components/footer-bottombar/footer-bottombar.component';
import { MinimizedConversationPanelComponent } from './components/minimized-conversation-panel/minimized-conversation-panel.component';
import { MobilePageFooterComponent } from './components/mobile-page-footer/mobile-page-footer.component';
import { NotificationResultsComponent } from './components/notifications-panel/notification-results/notification-results.component';
import { SingleNotificationComponent } from './components/notifications-panel/notification-results/single-notification/single-notification.component';
import { NotificationsPanelComponent } from './components/notifications-panel/notifications-panel.component';
import { CategoryComponent } from './components/panel-header/category/category.component';
import { PanelHeaderComponent } from './components/panel-header/panel-header.component';
import { SeeMoreButtonComponent } from './components/see-more-button/see-more-button.component';
import { SimpleSharedModalComponent } from './components/simple-shared-modal/simple-shared-modal.component';
import { SortDropdownComponent } from './components/sort-dropdown/sort-dropdown.component';
import { DatePickerSidebarComponent } from './components/statistics-top-menu/range-picker/date-picker-sidebar/date-picker-sidebar.component';
import { DatePickerComponent } from './components/statistics-top-menu/range-picker/date-picker/date-picker.component';
import { RangePickerComponent } from './components/statistics-top-menu/range-picker/range-picker.component';
import { StatisticsTopMenuComponent } from './components/statistics-top-menu/statistics-top-menu.component';
import { ContactResultsComponent } from './components/support-panel/results-list/contact-results/contact-results.component';
import { FaqResultsComponent } from './components/support-panel/results-list/faq-results/faq-results.component';
import { ResultsListComponent } from './components/support-panel/results-list/results-list.component';
import { SupportPanelComponent } from './components/support-panel/support-panel.component';
import { SupportSubcategoriesComponent } from './components/support-panel/support-subcategories/support-subcategories.component';
import { TabletFooterComponent } from './components/tablet-footer/tablet-footer.component';
import { ToggleSwitchComponent } from './components/toggle-switch/toggle-switch.component';
import { CampaignCardActionButtonsComponent } from '@pages/campaigns/campaigns-list/available-campaigns/campaign-card/campaign-card-action-buttons/campaign-card-action-buttons.component';
import { CategoriesOrCountriesComponent } from '@pages/campaigns/campaigns-list/available-campaigns/campaign-card/categories-or-countries/categories-or-countries.component';
import { FilterSubelementsComponent } from '@pages/campaigns/campaigns-list/filters/filter-subelements/filter-subelements.component';
import { AddPromotionMethodModalComponent } from '@pages/ivr/my-configurations/modals/add-promotion-method-modal/add-promotion-method-modal.component';
import { PromotionMethodDescriptionComponent } from '@pages/ivr/my-configurations/modals/add-promotion-method-modal/promotion-method-description/promotion-method-description.component';
import { LoadedInvoiceComponent } from '@pages/payouts/payout/payout-form/payment-type/own-invoice/loaded-invoice/loaded-invoice.component';
import { OwnInvoiceComponent } from '@pages/payouts/payout/payout-form/payment-type/own-invoice/own-invoice.component';
import { AdblockModalComponent } from './components/adblock-modal/adblock-modal.component';
import { AddGeneralConfigFirstComponent } from './components/add-general-config-first/add-general-config-first.component';
import { AlertComponent } from './components/alert/alert.component';
import { AppliedFiltersBarComponent } from './components/applied-filters-bar/applied-filters-bar.component';
import { AvatarSettingsComponent } from './components/avatar-settings/avatar-settings.component';
import { AvatarWithBadgesComponent } from './components/avatar-with-badges/avatar-with-badges.component';
import { BadgeComponent } from './components/badge/badge.component';
import { CircleButtonsComponent } from './components/circle-buttons/circle-buttons.component';
import { CodeCopyPanelComponent } from './components/code-copy-panel/code-copy-panel.component';
import { ConfirmPageLeaveModalComponent } from './components/confirm-page-leave-modal/confirm-page-leave-modal.component';
import { ContentLockerBannersComponent } from './components/content-locker-banners/content-locker-banners.component';
import { TypersBoxComponent } from './components/conversation-panel/typers-box/typers-box.component';
import { CountriesCheckboxListComponent } from './components/countries-checkbox-list/countries-checkbox-list.component';
import { CountryCheckboxComponent } from './components/countries-checkbox-list/country-checkbox/country-checkbox.component';
import { DisplayOptionsComponent } from './components/display-options/display-options.component';
import { DragAndDropComponent } from './components/drag-and-drop/drag-and-drop.component';
import { FilterGroupComponent } from './components/filters/filter-group/filter-group.component';
import { FilterItemComponent } from './components/filters/filter-group/filter-item/filter-item.component';
import { FiltersComponent } from './components/filters/filters.component';
import { GlobalCheckboxComponent } from './components/global-checkbox/global-checkbox.component';
import { GlobalPaginationComponentComponent } from './components/global-pagination-component/global-pagination-component.component';
import { ImgUploadInputComponent } from './components/img-upload-input/img-upload-input.component';
import { SingleImgComponent } from './components/img-upload-input/single-img/single-img.component';
import { SelectComponent } from './components/inputs/select/select.component';
import { AssignIvrNumberComponent } from './components/ivr-ppi-modal-container/assign-ivr-number/assign-ivr-number.component';
import { CreateConfigurationComponent } from './components/ivr-ppi-modal-container/create-configuration/create-configuration.component';
import { SelectConfigurationContainerComponent } from './components/ivr-ppi-modal-container/create-configuration/select-configuration-container/select-configuration-container.component';
import { SelectConfigurationInputComponent } from './components/ivr-ppi-modal-container/create-configuration/select-configuration-container/select-configuration-input/select-configuration-input.component';
import { DownloadButtonsModalComponent } from './components/ivr-ppi-modal-container/download-buttons-modal/download-buttons-modal.component';
import { IvrPpiModalContainerComponent } from './components/ivr-ppi-modal-container/ivr-ppi-modal-container.component';
import { JoinProgramAlertComponent } from './components/join-program-alert/join-program-alert.component';
import { LabelComponent } from './components/label/label.component';
import { LoaderForListComponent } from './components/loader-for-list/loader-for-list.component';
import { LoaderForWidgetComponent } from './components/loader-for-widget/loader-for-widget.component';
import { LogoutModalComponent } from './components/logout-modal/logout-modal.component';
import { CheckboxInputComponent } from './components/modal-inputs/checkbox-input/checkbox-input.component';
import { ImgInputComponent } from './components/modal-inputs/img-input/img-input.component';
import { RadioInputComponent } from './components/modal-inputs/radio-input/radio-input.component';
import { SelectInputComponent } from './components/modal-inputs/select-input/select-input.component';
import { TextInputComponent } from './components/modal-inputs/text-input/text-input.component';
import { TextareaInputComponent } from './components/modal-inputs/textarea-input/textarea-input.component';
import { ModalComponent } from './components/modal/modal.component';
import { ForumLanguageSelectComponent } from './components/navigation-menu/forum-language-select/forum-language-select.component';
import { NewConversationSearchComponent } from './components/new-conversation-search/new-conversation-search.component';
import { PhoneNumberInputComponent } from './components/phone-number-input/phone-number-input.component';
import { PrefixSelectComponent } from './components/phone-number-input/prefix-select/prefix-select.component';
import { SinglePrefixComponent } from './components/phone-number-input/prefix-select/single-prefix/single-prefix.component';
import { ConfirmationOfKeyGenerationModalComponent } from './components/postback-security-key-modal/confirmation-of-key-generation-modal/confirmation-of-key-generation-modal.component';
import { PostbackSecurityKeyModalComponent } from './components/postback-security-key-modal/postback-security-key-modal.component';
import { PreviewWrapperComponent } from './components/preview-wrapper/preview-wrapper.component';
import { PrimaryButtonComponent } from './components/primary-button/primary-button.component';
import { RadioCheckboxComponent } from './components/radio-checkbox/radio-checkbox.component';
import { RemoteLoginAlertComponent } from './components/remote-login-alert/remote-login-alert.component';
import { ScrollableTabMenuComponent } from './components/scrollable-tab-menu/scrollable-tab-menu.component';
import { SearchAndSortPanelComponent } from './components/search-and-sort-panel/search-and-sort-panel.component';
import { SearchInputComponent } from './components/search-input/search-input.component';
import { SecondaryButtonComponent } from './components/secondary-button/secondary-button.component';
import { SelectButtonComponent } from './components/select-button/select-button.component';
import { SelectContainerComponent } from './components/select-container/select-container.component';
import { SharedSearchBarComponent } from './components/shared-search-bar/shared-search-bar.component';
import { ExportReportsComponent } from './components/statistics-top-menu/export-reports/export-reports.component';
import { ExportToFileComponent } from './components/statistics-top-menu/export-reports/export-to-file/export-to-file.component';
import { ReportsComponent } from './components/statistics-top-menu/export-reports/reports/reports.component';
import { SwitchLayoutButtonComponent } from './components/switch-layout-button/switch-layout-button.component';
import { TableFiltersComponent } from './components/table-filters/table-filters.component';
import { TertiaryButtonComponent } from './components/tertiary-button/tertiary-button.component';
import { TextInputModalComponent } from './components/text-input-modal/text-input-modal.component';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { PrivateChatListComponent } from './components/private-chat-list/private-chat-list.component';
import { SingleSectionComponent } from './components/private-chat-list/single-section/single-section.component';
import { ChatSearchBarComponent } from './components/private-chat-list/chat-search-bar/chat-search-bar.component';
import { PrivateChatUserComponent } from './components/private-chat-list/private-chat-user/private-chat-user.component';
import { PrivateChatHeaderComponent } from './components/private-chat-list/private-chat-user/private-chat-header/private-chat-header.component';
import { PrivateChatMessagesListComponent } from './components/private-chat-list/private-chat-user/private-chat-messages-list/private-chat-messages-list.component';
import { ChatHeaderFullViewComponent } from './components/private-chat-list/private-chat-user/chat-header-full-view/chat-header-full-view.component';
import { GeneratedUrlSharedComponent } from './components/generated-url-shared/generated-url-shared.component';
import { OpenDetailsModalButtonComponent } from './components/open-details-modal-button/open-details-modal-button.component';
import { FilterElementsComponent } from '@pages/campaigns/campaigns-list/filters/filter-elements/filter-elements.component';
import { FilterGroupsComponent } from '@pages/campaigns/campaigns-list/filters/filter-groups/filter-groups.component';
import { FiltersComponent as CampaignsFiltersComponent } from '@pages/campaigns/campaigns-list/filters/filters.component';
import { ConfirmationOfAddingPageComponent } from '@pages/for-webmaster/offer-pages/add-offer-page/confirmation-of-adding-page/confirmation-of-adding-page.component';
import { SinglePreferenceComponent } from '@pages/settings-and-preferences/general-wrapper/general/preferences/single-preference/single-preference.component';
import {
  ModeSwitchComponent,
  StatisitcsDatePickerComponent,
  StatisticsDatePickerSidebarComponent,
  StatisticsRangePickerComponent
} from '@pages/statistics/shared';

import { StatisticsTilesComponent } from '@pages/statistics/shared/statistics-tiles/statistics-tiles.component';
import { TilesFilterComponent } from '@pages/statistics/shared/statistics-tiles/tiles-filter/tiles-filter.component';
import { StatisticsTopMenuNewComponent } from '@pages/statistics/shared/statistics-top-menu-new/statistics-top-menu-new.component';
import { ChatMessagesComponent } from './components/conversation-panel/chat-messages/chat-messages.component';
import { CryptoWalletBannerComponent } from './components/crypto-wallet-banner/crypto-wallet-banner.component';
import { DocumentViewerComponent } from './components/document-viewer/document-viewer.component';
import { CheckboxComponent } from './components/inputs/checkbox/checkbox.component';
import { DateTimePickerComponent } from './components/inputs/date-time-picker/date-time-picker.component';
import { InputSearchComponent } from './components/inputs/input-search/input-search.component';
import { InputComponent } from './components/inputs/input/input.component';
import { ValidationErrorsComponent } from './components/inputs/validation-errors/validation-errors.component';
import { KnowledgeBaseModalComponent } from './components/knowledge-base-modal/knowledge-base-modal.component';
import { MyLeadLayout, MyLeadListLayout } from './components/layout';
import { MyConfigurationsPostbackComponent } from '@pages/postback-and-api/my-configurations-postback/my-configurations-postback.component';
import { CpaLockerCampaignCardComponent } from '@pages/content-locker/cpa-locker/cpa-locker-campaigns/cpa-locker-campaign-card/cpa-locker-campaign-card.component';
import { SinglePostbackUrlComponent } from '@pages/postback-and-api/single-postback-url/single-postback-url.component';
import { ColorInputComponent } from '@pages/for-webmaster/offer-pages/add-offer-page/create-offer-page/color-input/color-input.component';
import { SelectCampaignsSwitchComponent } from '@pages/for-webmaster/offer-pages/add-offer-page/create-offer-page/select-campaigns-switch/select-campaigns-switch.component';
// modals
import { AddEditConfigModalComponent } from '@app/shared/components/modals/add-edit-config-modal/add-edit-config-modal.component';
import { AdditionalLinkParametersComponent } from '@app/shared/components/modals/add-edit-config-modal/additional-link-parameters/additional-link-parameters.component';
import { PostbackUrlModalComponent } from '@app/shared/components/modals/postback-url-modal/postback-url-modal.component';
import { PostbackUrlParametersComponent } from '@app/shared/components/modals/postback-url-modal/postback-url-parameters/postback-url-parameters.component';
import { PostbackUrlComponent } from '@app/shared/components/modals/postback-url-modal/postback-url/postback-url.component';
import { ConfigurationCreatedInfoComponent } from '@app/shared/components/modals/add-edit-config-modal/configuration-created-info/configuration-created-info.component';
import { GeneratedUrlComponent } from '@app/shared/components/modals/add-edit-config-modal/generated-url/generated-url.component';
import { BannerCodeComponent } from '@app/shared/components/modals/banners-list-modal/banner-code/banner-code.component';
import { BannersListModalComponent } from '@app/shared/components/modals/banners-list-modal/banners-list-modal.component';
import { SingleBannerComponent } from '@app/shared/components/modals/banners-list-modal/single-banner/single-banner.component';
import { CategoryModalComponent } from '@app/shared/components/modals/category-modal/category-modal.component';
import { ConfigurationCreatedHeaderComponent } from '@app/shared/components/modals/configuration-created/configuration-created-header/configuration-created-header.component';
import { ConfigurationCreatedComponent } from '@app/shared/components/modals/configuration-created/configuration-created.component';
import { ConfigurationSelectionComponent } from '@app/shared/components/modals/configuration-selection/configuration-selection.component';
import { CountriesModalComponent } from '@app/shared/components/modals/countries-modal/countries-modal.component';
import { DeepLinkCreatedInfoComponent } from '@app/shared/components/modals/deep-link-modal/deep-link-created-info/deep-link-created-info.component';
import { DeepLinkModalComponent } from '@app/shared/components/modals/deep-link-modal/deep-link-modal.component';
import { GenerateUrlModalComponent } from '@app/shared/components/modals/generate-url-modal/generate-url-modal.component';
import { ProductGeneratedUrlComponent } from '@app/shared/components/modals/products-modal/product-generated-url/product-generated-url.component';
import { ProductInfoComponent } from '@app/shared/components/modals/products-modal/product-info/product-info.component';
import { ProductsDropdownComponent } from '@app/shared/components/modals/products-modal/products-dropdown/products-dropdown.component';
import { ProductsModalComponent } from '@app/shared/components/modals/products-modal/products-modal.component';
import { SingleProductComponent } from '@app/shared/components/modals/products-modal/single-product/single-product.component';
import { RateModalComponent } from '@app/shared/components/modals/rate-modal/rate-modal.component';
import { RatingComponent } from '@app/shared/components/modals/rate-modal/rating/rating.component';
import { SingleCampaignModalComponent } from '@app/shared/components/modals/single-campaign-modal.component';
import { ConfirmationModalComponent } from '@app/shared/components/modals/traffic-source-management-modal/confirmation-modal/confirmation-modal.component';
import { SingleTrafficSourceComponent } from '@app/shared/components/modals/traffic-source-management-modal/single-traffic-source/single-traffic-source.component';
import { TrafficSourceManagementModalComponent } from '@app/shared/components/modals/traffic-source-management-modal/traffic-source-management-modal.component';
import { TrafficSourceModalComponent } from '@app/shared/components/modals/traffic-source-modal/traffic-source-modal.component';
import { ProgramConditionsComponent } from '@app/shared/components/modals/verification-modal/program-conditions/program-conditions.component';
import { TrafficSourceComponent } from '@app/shared/components/modals/verification-modal/traffic-source/traffic-source.component';
import { VerificationModalComponent } from '@app/shared/components/modals/verification-modal/verification-modal.component';
import { BlockIpComponent } from '@app/shared/components/modals/block-ip/block-ip.component';
import { SingleIpAddressComponent } from '@app/shared/components/modals/block-ip/single-ip-address/single-ip-address.component';
import { CodeOptionsCheckboxesComponent } from '@app/shared/components/modals/codes-modal/code-options-checkboxes/code-options-checkboxes.component';
import { SingleParameterInputComponent } from '@app/shared/components/modals/codes-modal/code-options-checkboxes/single-parameter-input/single-parameter-input.component';
import { CodesModalComponent } from '@app/shared/components/modals/codes-modal/codes-modal.component';
import { DomainSelectionComponent } from '@app/shared/components/modals/codes-modal/domain-selection/domain-selection.component';
import { RewardsListComponent } from '@app/shared/components/modals/rewards-list/rewards-list.component';
import { SocialMediaComponent } from '@app/shared/components/modals/add-traffic-source-modal/details-section/social-media/social-media.component';
import { AddTrafficSourceModalComponent } from '@app/shared/components/modals/add-traffic-source-modal/add-traffic-source-modal.component';
import { LabelContainerComponent } from '@app/shared/components/modals/add-traffic-source-modal/label-container/label-container.component';
import { DetailsSectionComponent } from '@app/shared/components/modals/add-traffic-source-modal/details-section/details-section.component';
import { TypesSectionComponent } from '@app/shared/components/modals/add-traffic-source-modal/types-section/types-section.component';
import { TrafficSourceCategoriesComponent } from '@app/shared/components/modals/add-traffic-source-modal/details-section/traffic-source-categories/traffic-source-categories.component';
import { TrafficSourceCategoryElementsComponent } from '@app/shared/components/modals/add-traffic-source-modal/details-section/traffic-source-categories/traffic-source-category-elements/traffic-source-category-elements.component';
import { TrafficSourceCategorySubelementsComponent } from '@app/shared/components/modals/add-traffic-source-modal/details-section/traffic-source-categories/traffic-source-category-subelements/traffic-source-category-subelements.component';
import { AddTrafficSourceSummaryComponent } from '@app/shared/components/modals/add-traffic-source-modal/add-traffic-source-summary/add-traffic-source-summary.component';
import { TrafficSourceDetailsModalComponent } from '@app/shared/components/modals/traffic-source-details-modal/traffic-source-details-modal.component';
import { PostbackTestModalComponent } from '@app/shared/components/modals/postback-url-modal/postback-test-modal/postback-test-modal.component';
import { BannerContainerComponent } from '@app/shared/components/banner-container/banner-container.component';
import { DiscordBannerComponent } from '@app/shared/components/discord-banner/discord-banner.component';
//END COMPONENTS

//START MOUDLES
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NbIconModule } from '@nebular/theme';
import { NgbModule, NgbTimepickerModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { IMaskModule } from 'angular-imask';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { SidebarModule } from './components/sidebar/sidebar.module';
import { TranslateModule } from '@ngx-translate/core';
import { DrirectivesModule } from './directives/drirectives.module';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { HIGHLIGHT_OPTIONS, HighlightModule } from 'ngx-highlightjs';
import { MomentModule } from 'ngx-moment';
import { NgbRatingModule } from '@ng-bootstrap/ng-bootstrap';
import { ColorPickerModule } from 'ngx-color-picker';
//END MOUDLES

//START PIPES
import { SearchCountryPipe } from './pipes/search-country.pipe';
import { BannerSizeFilterPipe } from './pipes/banner-size-filter.pipe';
import { ChangeDateCommaPipe } from './pipes/change-date-comma.pipe';
import { ChangeDateFormatPipe } from './pipes/change-date-format.pipe';
import { ChangeThousandsSeparatorPipe } from './pipes/change-thousands-separator.pipe';
import { FileSizePipe } from './pipes/file-size.pipe';
import { RecentCreatedAtPipe } from './pipes/recent-created-at.pipe';
import { SanitizeHtmlPipe } from './pipes/sanitize-html.pipe';
import { SearchPipe } from './pipes/search.pipe';
import { AsyncStatusPipe } from './pipes/async-status.pipe';
import { NumberFormatPipe } from './pipes/number-format.pipe';
import { ParseWidgetNamePipe } from './pipes/parse-widget-name.pipe';
import { SwitchMultiCasePipe } from './pipes/switch-multi-case.pipe';
import { TranslatePipe } from './pipes/translate.pipe';
import { TranslateEmojiPipe } from '@app/shared/pipes/translate-emoji.pipe';
import { RemoveWhitespacePipe } from './pipes/remove-whitespace.pipe';
import { CleanContentPipe } from './pipes/clean-content.pipe';
//END PIPES

//START SERVICES
import { AssetResolver } from '@app/core/resolvers/asset-resolver.service';
import { GlobalNotificationsContainerComponent } from './components/global-notifications-container/global-notifications-container/global-notifications-container.component';
//END SERVICES

@NgModule({
  declarations: [
    //START COMPONENTS
    NavigationMenuComponent,
    SmallButtonComponent,
    UserAccountButtonComponent,
    TopMenuBarComponent,
    GlobalLocalAlertsComponent,
    UserPanelComponent,
    UserPanelHeaderComponent,
    UserPanelBodyComponent,
    UserPanelFooterComponent,
    SearchBarComponent,
    PopularTagsContainerComponent,
    ResultsContainerComponent,
    DefaultContainerComponent,
    SingleTagComponent,
    CategoriesComponent,
    FooterBottombarComponent,
    NotificationsPanelComponent,
    PanelHeaderComponent,
    CategoryComponent,
    NotificationResultsComponent,
    SingleNotificationComponent,
    SupportPanelComponent,
    SupportSubcategoriesComponent,
    ResultsListComponent,
    FaqResultsComponent,
    ContactResultsComponent,
    ActionButtonComponent,
    ConversationPanelComponent,
    SeeMoreButtonComponent,
    MinimizedConversationPanelComponent,
    SingleMessageComponent,
    ChatCreateMessageComponent,
    CreateMessageComponent,
    AchievementsComponent,
    StatisticsTopMenuComponent,
    RangePickerComponent,
    DatePickerComponent,
    DatePickerSidebarComponent,
    MobilePageFooterComponent,
    TabletFooterComponent,
    FooterMenuComponent,
    FooterMobileAppsComponent,
    FooterBottomBarComponent,
    FooterAppListComponent,
    ToggleSwitchComponent,
    FaqInformationsComponent,
    FaqInformationsItemComponent,
    EnlargedSectionsTitleComponent,
    SortDropdownComponent,
    SimpleSharedModalComponent,
    JoinProgramAlertComponent,
    SelectButtonComponent,
    GlobalCheckboxComponent,
    PrimaryButtonComponent,
    SecondaryButtonComponent,
    TertiaryButtonComponent,
    CircleButtonsComponent,
    SelectContainerComponent,
    ConfirmPageLeaveModalComponent,
    ExportReportsComponent,
    ExportToFileComponent,
    ReportsComponent,
    SearchInputComponent,
    LogoutModalComponent,
    SearchInputComponent,
    JoinProgramAlertComponent,
    SelectButtonComponent,
    ExportReportsComponent,
    ExportToFileComponent,
    ReportsComponent,
    AppliedFiltersBarComponent,
    CheckboxInputComponent,
    TextInputComponent,
    TextareaInputComponent,
    RadioInputComponent,
    SelectInputComponent,
    ImgInputComponent,
    TextInputModalComponent,
    ForumLanguageSelectComponent,
    SwitchLayoutButtonComponent,
    GlobalPaginationComponentComponent,
    CountriesCheckboxListComponent,
    CountryCheckboxComponent,
    IvrPpiModalContainerComponent,
    CreateConfigurationComponent,
    AssignIvrNumberComponent,
    SelectConfigurationContainerComponent,
    SelectConfigurationInputComponent,
    DownloadButtonsModalComponent,
    AddGeneralConfigFirstComponent,
    DisplayOptionsComponent,
    TypersBoxComponent,
    TooltipComponent,
    PostbackSecurityKeyModalComponent,
    ConfirmationOfKeyGenerationModalComponent,
    PhoneNumberInputComponent,
    PrefixSelectComponent,
    SinglePrefixComponent,
    StatisticsTilesComponent,
    TilesFilterComponent,
    RemoteLoginAlertComponent,
    NewConversationSearchComponent,
    ContentLockerBannersComponent,
    SharedSearchBarComponent,
    ImgUploadInputComponent,
    SingleImgComponent,
    SearchAndSortPanelComponent,
    CodeCopyPanelComponent,
    AvatarWithBadgesComponent,
    AvatarSettingsComponent,
    OwnInvoiceComponent,
    LoadedInvoiceComponent,
    RadioCheckboxComponent,
    PreviewWrapperComponent,
    AddPromotionMethodModalComponent,
    PromotionMethodDescriptionComponent,
    FilterSubelementsComponent,
    ScrollableTabMenuComponent,
    LoaderForWidgetComponent,
    LoaderForListComponent,
    ModalComponent,
    SelectComponent,
    FiltersComponent,
    FilterGroupComponent,
    FilterItemComponent,
    CategoriesOrCountriesComponent,
    BadgeComponent,
    CampaignCardActionButtonsComponent,
    AlertComponent,
    LabelComponent,
    AdblockModalComponent,
    KnowledgeBaseModalComponent,
    TableFiltersComponent,
    InputSearchComponent,
    StatisticsTopMenuNewComponent,
    StatisitcsDatePickerComponent,
    StatisticsRangePickerComponent,
    StatisticsDatePickerSidebarComponent,
    InputComponent,
    ValidationErrorsComponent,
    CheckboxComponent,
    ...MyLeadLayout,
    ...MyLeadListLayout,
    CryptoWalletBannerComponent,
    CryptoWalletBannerComponent,
    DocumentViewerComponent,
    DateTimePickerComponent,
    GeneratedUrlSharedComponent,
    OpenDetailsModalButtonComponent,
    SinglePreferenceComponent,
    CampaignsFiltersComponent,
    FilterElementsComponent,
    FilterGroupsComponent,
    PostbackUrlModalComponent,
    PostbackUrlComponent,
    PostbackUrlParametersComponent,
    AddEditConfigModalComponent,
    AdditionalLinkParametersComponent,
    ConfirmationOfAddingPageComponent,
    ChatMessagesComponent,
    ModeSwitchComponent,
    MyConfigurationsPostbackComponent,
    CpaLockerCampaignCardComponent,
    SinglePostbackUrlComponent,
    ColorInputComponent,
    SelectCampaignsSwitchComponent,
    PrivateChatListComponent,
    SingleSectionComponent,
    ChatSearchBarComponent,
    PrivateChatUserComponent,
    PrivateChatHeaderComponent,
    PrivateChatMessagesListComponent,
    ChatHeaderFullViewComponent,
    GlobalNotificationsContainerComponent,
    //modals
    SingleCampaignModalComponent,
    VerificationModalComponent,
    TrafficSourceComponent,
    ProgramConditionsComponent,
    ConfigurationCreatedInfoComponent,
    GeneratedUrlComponent,
    BannersListModalComponent,
    SingleBannerComponent,
    ConfigurationCreatedComponent,
    ConfigurationCreatedInfoComponent,
    ConfigurationSelectionComponent,
    BannerCodeComponent,
    DeepLinkModalComponent,
    DeepLinkCreatedInfoComponent,
    ProductsModalComponent,
    SingleProductComponent,
    ProductInfoComponent,
    ProductGeneratedUrlComponent,
    ProductsDropdownComponent,
    CountriesModalComponent,
    CountriesModalComponent,
    TrafficSourceModalComponent,
    ConfigurationCreatedHeaderComponent,
    GenerateUrlModalComponent,
    TrafficSourceModalComponent,
    TrafficSourceManagementModalComponent,
    SingleTrafficSourceComponent,
    CategoryModalComponent,
    RateModalComponent,
    RatingComponent,
    ConfirmationModalComponent,
    CodesModalComponent,
    DomainSelectionComponent,
    CodeOptionsCheckboxesComponent,
    SingleParameterInputComponent,
    BlockIpComponent,
    SingleIpAddressComponent,
    RewardsListComponent,
    AddTrafficSourceModalComponent,
    LabelContainerComponent,
    DetailsSectionComponent,
    TypesSectionComponent,
    SocialMediaComponent,
    TrafficSourceCategoriesComponent,
    TrafficSourceCategoryElementsComponent,
    TrafficSourceCategorySubelementsComponent,
    AddTrafficSourceSummaryComponent,
    TrafficSourceDetailsModalComponent,
    PostbackTestModalComponent,
    DragAndDropComponent,
    BannerContainerComponent,
    DiscordBannerComponent,
    //END COMPONENTS

    //START PIPES
    RemoveWhitespacePipe,
    NumberFormatPipe,
    SwitchMultiCasePipe,
    TranslatePipe,
    AsyncStatusPipe,
    ParseWidgetNamePipe,
    ChangeDateCommaPipe,
    FileSizePipe,
    SanitizeHtmlPipe,
    RecentCreatedAtPipe,
    SearchPipe,
    ChangeThousandsSeparatorPipe,
    ChangeDateFormatPipe,
    SearchCountryPipe,
    BannerSizeFilterPipe,
    CleanContentPipe
    //END PIPES
  ],
  imports: [
    CommonModule,
    NbIconModule,
    TranslateModule,
    SidebarModule,
    RouterModule,
    DrirectivesModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgSelectModule,
    HighlightModule,
    MomentModule,
    PickerModule,
    EmojiComponent,
    InfiniteScrollModule,
    IMaskModule,
    NgbRatingModule,
    ColorPickerModule,
    TranslateEmojiPipe,
    NgbTimepickerModule,
    NgOptimizedImage,
    NgbTooltipModule
  ],
  exports: [
    //START COMPONENTS
    GlobalPaginationComponentComponent,
    NavigationMenuComponent,
    SmallButtonComponent,
    UserAccountButtonComponent,
    TopMenuBarComponent,
    GlobalLocalAlertsComponent,
    UserPanelComponent,
    FooterBottombarComponent,
    ConversationPanelComponent,
    MinimizedConversationPanelComponent,
    MobilePageFooterComponent,
    TabletFooterComponent,
    FooterMenuComponent,
    FooterMobileAppsComponent,
    FooterBottomBarComponent,
    FooterAppListComponent,
    ToggleSwitchComponent,
    FaqInformationsComponent,
    FaqInformationsItemComponent,
    EnlargedSectionsTitleComponent,
    SortDropdownComponent,
    ActionButtonComponent,
    SimpleSharedModalComponent,
    JoinProgramAlertComponent,
    SelectButtonComponent,
    GlobalCheckboxComponent,
    PrimaryButtonComponent,
    SecondaryButtonComponent,
    TertiaryButtonComponent,
    CircleButtonsComponent,
    SelectContainerComponent,
    ExportReportsComponent,
    SearchInputComponent,
    JoinProgramAlertComponent,
    SelectButtonComponent,
    SortDropdownComponent,
    ExportReportsComponent,
    AppliedFiltersBarComponent,
    CheckboxInputComponent,
    TextInputComponent,
    TextareaInputComponent,
    RadioInputComponent,
    SelectInputComponent,
    ImgInputComponent,
    SwitchLayoutButtonComponent,
    CountriesCheckboxListComponent,
    CountryCheckboxComponent,
    IvrPpiModalContainerComponent,
    AddGeneralConfigFirstComponent,
    DisplayOptionsComponent,
    TooltipComponent,
    SupportSubcategoriesComponent,
    ContactResultsComponent,
    PhoneNumberInputComponent,
    PrefixSelectComponent,
    SinglePrefixComponent,
    StatisticsTilesComponent,
    TilesFilterComponent,
    RemoteLoginAlertComponent,
    RangePickerComponent,
    DatePickerSidebarComponent,
    DatePickerComponent,
    StatisticsTopMenuComponent,
    ContentLockerBannersComponent,
    ImgUploadInputComponent,
    SingleImgComponent,
    SearchAndSortPanelComponent,
    CodeCopyPanelComponent,
    AvatarWithBadgesComponent,
    AvatarSettingsComponent,
    OwnInvoiceComponent,
    LoadedInvoiceComponent,
    RadioCheckboxComponent,
    PreviewWrapperComponent,
    FilterSubelementsComponent,
    ScrollableTabMenuComponent,
    LoaderForWidgetComponent,
    LoaderForListComponent,
    ModalComponent,
    SelectComponent,
    FiltersComponent,
    FilterGroupComponent,
    FilterItemComponent,
    CategoriesOrCountriesComponent,
    BadgeComponent,
    CampaignCardActionButtonsComponent,
    AlertComponent,
    LabelComponent,
    TableFiltersComponent,
    InputSearchComponent,
    StatisticsTopMenuNewComponent,
    StatisitcsDatePickerComponent,
    StatisticsRangePickerComponent,
    StatisticsDatePickerSidebarComponent,
    InputComponent,
    CheckboxComponent,
    ...MyLeadLayout,
    ...MyLeadListLayout,
    CryptoWalletBannerComponent,
    CryptoWalletBannerComponent,
    DateTimePickerComponent,
    OpenDetailsModalButtonComponent,
    SinglePreferenceComponent,
    CampaignsFiltersComponent,
    FilterElementsComponent,
    FilterGroupsComponent,
    PostbackUrlModalComponent,
    PostbackUrlComponent,
    PostbackUrlParametersComponent,
    AddEditConfigModalComponent,
    AdditionalLinkParametersComponent,
    ConfirmationOfAddingPageComponent,
    SharedSearchBarComponent,
    TypersBoxComponent,
    ChatMessagesComponent,
    NewConversationSearchComponent,
    PopularTagsContainerComponent,
    ChatCreateMessageComponent,
    ModeSwitchComponent,
    MyConfigurationsPostbackComponent,
    CpaLockerCampaignCardComponent,
    SinglePostbackUrlComponent,
    ColorInputComponent,
    SelectCampaignsSwitchComponent,
    PrivateChatListComponent,
    SingleSectionComponent,
    ChatSearchBarComponent,
    PrivateChatUserComponent,
    PrivateChatHeaderComponent,
    PrivateChatMessagesListComponent,
    ChatHeaderFullViewComponent,
    SingleCampaignModalComponent,
    GeneratedUrlComponent,
    GlobalNotificationsContainerComponent,
    DragAndDropComponent,
    BannerContainerComponent,
    DiscordBannerComponent,
    //END COMPONENTS

    //START MOUDLES
    CommonModule,
    NbIconModule,
    TranslateModule,
    SidebarModule,
    RouterModule,
    DrirectivesModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgSelectModule,
    HighlightModule,
    MomentModule,
    PickerModule,
    EmojiComponent,
    InfiniteScrollModule,
    IMaskModule,
    NgbRatingModule,
    ColorPickerModule,
    TranslateEmojiPipe,
    NgbTimepickerModule,
    NgOptimizedImage,
    NgbTooltipModule,
    //END MOUDLES

    //START PIPES
    TranslateEmojiPipe,
    RemoveWhitespacePipe,
    NumberFormatPipe,
    SwitchMultiCasePipe,
    TranslatePipe,
    AsyncStatusPipe,
    ParseWidgetNamePipe,
    RecentCreatedAtPipe,
    ChangeDateCommaPipe,
    FileSizePipe,
    SanitizeHtmlPipe,
    ChangeDateFormatPipe,
    SearchPipe,
    ChangeThousandsSeparatorPipe,
    SearchCountryPipe,
    BannerSizeFilterPipe,
    ProductsDropdownComponent,
    CleanContentPipe
    //END PIPES
  ],
  providers: [
    BannerSizeFilterPipe,
    AssetResolver,
    {
      provide: HIGHLIGHT_OPTIONS,
      useValue: {
        coreLibraryLoader: () => import('highlight.js/lib/core'),
        languages: {
          typescript: () => import('highlight.js/lib/languages/typescript'),
          css: () => import('highlight.js/lib/languages/css')
        }
      }
    }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule {}
